import { getLoaders } from 'entities/_config';

import { apiCall } from 'services/api';
import { Survey } from './types';

export const surveyLoaders = getLoaders({
  eligibleSurveys: {
    load: async (): Promise<Survey[]> => {
      return apiCall({
        path: '/surveys/available',
        method: 'get',
      });
    },
  },
});
